'use strict';

angular.module('msUtility').directive('msRangeSlider', [function () {
  return {
    restrict: 'A',
    scope: false,
    require: 'ngModel',
    link: function link(scope, element, attrs, ngModel) {
      var hasRendered = false;
      element.rangeslider({
        polyfill: false,
        onSlide: function onSlide(position, value) {
          if (hasRendered) {
            ngModel.$setViewValue(value);
          }
        }
      });
      ngModel.$render = function () {
        if (ngModel.$viewValue) {
          element.val(ngModel.$viewValue).change();
        }
        hasRendered = true;
      };
    }
  };
}]);